import { createAction, props } from '@ngrx/store';
import { DropdownData } from '@zayan-erp/shared';

export const loadProjects = createAction('[Projects] Load Projects');
export const loadProjectsSuccess = createAction(
  '[Projects] Load Projects Success',
  props<{ projects: DropdownData[] }>()
);

export const loadLots = createAction('[Lots] Load Lots');
export const loadLotsSuccess = createAction('[Lots] Load Lots Success', props<{ lots: DropdownData[] }>());

// export const loadProjectLots = createAction('[ProjectLots] Load ProjectLots', props<{ force: boolean }>());
export const loadProjectLotsSuccess = createAction(
  '[ProjectLots] Load ProjectLots Success',
  props<{ projectLots: { [projectId: string]: DropdownData[] } }>()
);

export const selectedProject = createAction(
  '[SelectedProject] Load SelectedProject',
  props<{ projectId: string | null; force?: boolean }>()
);

export const loadCities = createAction('[Cities] Load Cities');
export const loadCitiesSuccess = createAction('[Cities] Load Cities Success', props<{ cities: DropdownData[] }>());

export const loadProductList = createAction('[ProductList] Load ProductList');
export const loadProductListSuccess = createAction(
  '[ProductList] Load ProductList Success',
  props<{ productList: DropdownData[] }>()
);

export const loadCategoryList = createAction('[CategoryList] Load CategoryList');
export const loadCategoryListSuccess = createAction(
  '[CategoryList] Load CategoryList Success',
  props<{ categoryList: DropdownData[] }>()
);

export const loadSubcategories = createAction(
  '[Subcategories] Load Subcategories',
  props<{ productListId: string; categoryListId: string; force?: boolean }>()
);
export const loadSubcategoriesSuccess = createAction(
  '[Subcategories] Load Subcategories Success',
  props<{ subcategories: { [categoryListId: string]: DropdownData[] } }>()
);

export const loadCategoryListByProductListId = createAction(
  '[CategoryListByProductListId] Load CategoryListByProductListId',
  props<{ productListId: string; force?: boolean }>()
);
export const loadCategoryListByProductListIdSuccess = createAction(
  '[CategoryListByProductListId] Load CategoryListByProductListId Success',
  props<{ categoryListByProductListId: { [productListId: string]: DropdownData[] } }>()
);

export const loadUofms = createAction('[Uofms] Load Uofms');
export const loadUofmsSuccess = createAction('[Uofms] Load Uofms Success', props<{ uofms: DropdownData[] }>());

export const loadProjectLocations = createAction('[ProjectLocations] Load ProjectLocations');
export const loadProjectLocationsSuccess = createAction(
  '[ProjectLocations] Load ProjectLocations Success',
  props<{ locations: DropdownData[] }>()
);

// Countries
export const loadCountries = createAction('[Countries] Load Countries');
export const loadCountriesSuccess = createAction(
  '[Countries] Load Countries Success',
  props<{ countries: DropdownData[] }>()
);

// Cities
export const loadCitiesByCountryId = createAction('[Cities] Load Cities By Country Id', props<{ countryId: string }>());
export const loadCitiesByCountryIdSuccess = createAction(
  '[Cities] Load Cities By Country Id Success',
  props<{ cities: DropdownData[] }>()
);

export const setTemplateTypes = createAction(
  '[TemplateTypes] Set TemplateTypes',
  props<{ templateTypes: DropdownData[] }>()
);
